import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { css } from 'aphrodite';

import { Font, Text, Layout, Flexbox } from './Styles';
import ScenarioIcon from './ScenarioIcon';
import PrimaryButton from './PrimaryButton';

import Locale from './models/Locale';

class ScenarioPicker extends Component {
  render() {
    return(
      <div className={css(Layout.fullScrollingContentArea)}>
        <div className={css(Layout.contentArea)}>
          <div className={css(Flexbox.column, Flexbox.axisCenter, Flexbox.crossCenter)}>
            <div className={css(Font.hero, Text.heading)}>{Locale.localized("Choose A Location")}</div>
            <div className={css(Flexbox.row, Flexbox.axisCenter, Flexbox.crossFill, Flexbox.centeredItem, Flexbox.grow, Flexbox.wrap)}>
              <ScenarioIcon cityNumber={0} />
              <ScenarioIcon cityNumber={1} />
              <ScenarioIcon cityNumber={2} />
              <ScenarioIcon cityNumber={3} />
              <ScenarioIcon cityNumber={4} />
              <ScenarioIcon cityNumber={5} />
            </div>
          </div>
        </div>
        <Link to="/">
          <PrimaryButton>{Locale.localized("Go Back")}</PrimaryButton>
        </Link>
      </div>
    );
  }
}

export default ScenarioPicker;



// WEBPACK FOOTER //
// ./src/ScenarioPicker.js